export default __webpack_public_path__ + "3bd2a78c03872c21154350a6fc3e1001.png";